const history = {
  title: 'Mijn Projecten',
  upgradeBtn: 'Upgrade',
  subTitle:
    'Vergeet niet uw bestand te downloaden, want het wordt na 72 uur verwijderd.',
  MAgo: '{{num}} minuten geleden',
  HAgo: '{{num}} uren geleden',
  DAgo: '{{num}} uren geleden',
  justNow: 'Nu net',
  originalFile: 'Origineel bestand',
  selectAllBtn: 'Alles selecteren',
  emptyTips: 'Nog geen proiect. <1>Ga bewerken</1>',
  deleteTips: 'Weet u zeker dat u het wilt verwijderen?',
};

export default history;
